enum UserBookmarkType {
    Section = 1,
    Table = 2,
}

export default UserBookmarkType;
